import { Outlet, useLoaderData } from 'react-router';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams.js';
import { isStrictFeatureEnabled } from '../../../../../common/utils/featureFlagUtils.js';
import { CatalogList } from '../../../../../components/CatalogList/CatalogList.js';
import {
  CompanyInfoContainer,
  CompanyInfoSceneTab,
} from '../../../../../components/CompanyInfoScene/CompanyInfoScene.js';
import { DeviceListTabsCoCo } from '../../../../../components/DeviceListTabsCoCo/DeviceListTabsCoCo.js';
import { useAuth } from '../../../AuthProvider.js';
import { useFeatureFlags } from '../../../ConfigProvider.js';
import type { DeviceListTabsLoaderDataCoCo } from '../../../../../common/loaders.js';
import type { CatalogListProps } from '../../../../../components/CatalogList/CatalogList.js';
import type { VirtualCatalogResponse } from '../../../../../generated/api/models.js';

export const CompanyInfoCatalogsOutlet = () => {
  return <Outlet />;
};

export const CompanyInfoCatalogsPath = () => {
  const loaderData = useLoaderData() as VirtualCatalogResponse | DeviceListTabsLoaderDataCoCo | undefined;
  const { search, productType, contractPeriod, status } = useSearchParams<{
    search?: string;
    productType?: string;
    contractPeriod?: string;
    status?: string;
  }>();
  const { authenticatedUser } = useAuth();
  const cocoEnabled = isStrictFeatureEnabled(useFeatureFlags().coco);

  if (cocoEnabled) {
    const { deviceSelections, employeeProductLists } = loaderData as DeviceListTabsLoaderDataCoCo;
    return (
      <CompanyInfoContainer tab={CompanyInfoSceneTab.CATALOGS}>
        <DeviceListTabsCoCo deviceSelections={deviceSelections} employeeProductLists={employeeProductLists} />
      </CompanyInfoContainer>
    );
  }

  const {
    searchResults: virtualCatalogs,
    resultCountAggregations: aggregations,
    total: totalItems,
  } = loaderData as VirtualCatalogResponse;
  const catalogListProps: CatalogListProps = {
    searchInput: search,
    totalItems,
    virtualCatalogs,
    productTypeFilter: productType,
    contractPeriodFilter: contractPeriod,
    statusFilter: status,
    aggregations,
    authenticatedUser,
  };

  return (
    <CompanyInfoContainer tab={CompanyInfoSceneTab.CATALOGS}>
      <CatalogList {...catalogListProps} />
    </CompanyInfoContainer>
  );
};
